import React from 'react';
import style from './styles.module.scss';
import { useTranslation } from '@hooks/index';

interface DragDropCardTitleProps {
    title: string;
    numberOfRecords?: number;
}

const DragDropCardTitle = ({ title, numberOfRecords }: DragDropCardTitleProps) => {
    const { t } = useTranslation();

    return (
        <div className="k-d-flex k-align-items-center">
            <span>{title}</span>
            <span className={style.recordsNumber}>
                ({numberOfRecords ?? 0} {t('records')})
            </span>
        </div>
    );
};

export default DragDropCardTitle;
